import { gql } from "@apollo/client"
import DownloadLinkFields from "~/app/queries/fragments/DownloadLinkFields"

export const InvoiceFields = gql`
  fragment InvoiceFields on Invoice {
    id
    amount {
      currencyCode
      subunit
    }
    amountDue {
      currencyCode
      subunit
    }
    amountCurrencyCode
    chargePaymentRequest {
      ordersState
      targetAmount {
        currencyCode
        subunit
        formatted
      }
    }
    payoutPaymentRequest {
      ordersState
      viewState
      targetAmount {
        currencyCode
        subunit
        formatted
      }
    }
    createdAt
    dueDate
    invoiceDate
    paymentPeriod
    notes
    referenceCode
    sentAt
    paidAt
    voidedAt
    state
    kind
    isOverdue
    canDispute
    file {
      ...DownloadLinkFields
    }
    supportingFile {
      ...DownloadLinkFields
    }
    company {
      id
      name
      avatarUrl
    }
    contract {
      id
      name
    }
  }
  ${DownloadLinkFields}
`
